import { FinancialDriver, FinancialItem } from '@upright/common/model/input/materiality-assessment/types';

/**
 * Source of truth for valid financial items for each driver.
 * Reference: @link https://docs.google.com/spreadsheets/d/17WTTRvAdGTr8MaL2eT3PL-5CtFiVT14Mb7eLXqng0Xk/edit?gid=199852758#gid=199852758
 */
export const driverToValidFinancialItems: Record<FinancialDriver, FinancialItem[]> = {
  [FinancialDriver.INVESTORS]: [FinancialItem.COST_OF_CAPITAL],
  [FinancialDriver.EMPLOYEES]: [FinancialItem.SGA_AND_RD_COSTS],
  [FinancialDriver.REGULATORS]: [FinancialItem.OTHER_OPERATING_EXPENSES, FinancialItem.CAPEX],
  [FinancialDriver.CONSUMERS]: [FinancialItem.REVENUE],
  [FinancialDriver.NATURE]: [FinancialItem.CAPEX, FinancialItem.TANGIBLE_ASSETS],
  [FinancialDriver.SUPPLIERS]: [FinancialItem.COST_OF_REVENUE],
};
